/**
 * Domain Environment Formatter.
 * @param {*} value
 * @param {Object} row
 * @returns {String|*}
 */
window.domainEnvironmentFormatter = function(value, row) {
    let html = '';
    switch (value) {
        case 'local':
            html += '<span class="badge badge-local">';
            html += __('Local');
            html += '</span>';
            break;
        case 'staging':
            html += '<span class="badge badge-staging">';
            html += __('Staging');
            html += '</span>';
            break;
        case 'production':
            html += '<span class="badge badge-production">';
            html += __('Production');
            html += '</span>';
            break;
        case 'testing':
            html += '<span class="badge badge-testing">';
            html += __('Testing');
            html += '</span>';
            break;
    }
    return html;
};
